import { REACT_APP_STRAPI_BASE_URL } from './config';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Helper to load translations safely
const loadTranslations = async (lang: string) => {
  try {
    const [adminPanelResponse, emailResponse] = await Promise.all([
      fetch(`${REACT_APP_STRAPI_BASE_URL}/admin-panel-translations/key-value?code=${lang}`),
      fetch(`${REACT_APP_STRAPI_BASE_URL}/email-translations/key-value?code=${lang}`)
    ]);

    if (!adminPanelResponse.ok || !emailResponse.ok) {
      throw new Error(`Failed to load ${lang} translations`);
    }

    const [adminPanelData, emailData] = await Promise.all([
      adminPanelResponse.json(),
      emailResponse.json()
    ]);
    //  Merge both translations (email overrides admin if keys clash)
    return {
      ...adminPanelData,
      ...emailData
    };
  } catch (err) {
    console.error(`⚠️ Error loading ${lang} translations:`, err);
    return {}; // fallback empty translations
  }
};

// Get saved language (default to 'en')
const savedLang = localStorage.getItem('selectedLanguage') || 'de';

// Synchronous fallback data — avoids crash during initialization
const fallbackResources = {
  en: { translation: {} },
  de: { translation: {} }
};

// Initialize i18n immediately with saved language
i18n.use(initReactI18next).init({
  resources: fallbackResources,
  lng: savedLang, // use saved language on startup
  fallbackLng: 'en',
  debug: false,
  interpolation: { escapeValue: false }
});

// Load real translations asynchronously (after init)
(async () => {
  const [en, de] = await Promise.all([loadTranslations('en'), loadTranslations('de')]);

  i18n.addResources('en', 'translation', en);
  i18n.addResources('de', 'translation', de);

  // ensure language is reapplied after translations load
  i18n.changeLanguage(savedLang);
})();

export default i18n;
